import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_REQUESTS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_REQUESTS_MANAGEMENT.STATE.REQUEST_SESSION]: null,
  [LOT_REQUESTS_MANAGEMENT.STATE.REQUESTS]: null,
  [LOT_REQUESTS_MANAGEMENT.STATE.CURRENT_REQUEST]: null,
  [LOT_REQUESTS_MANAGEMENT.STATE.LAST]: null
}

const actions = {
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.GET_LOT_REQUESTS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests?${Vue.helpers.getQueryParamsString(model.params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LOT_REQUESTS, resp.data)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.GET_LOT_REQUEST_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LOT_REQUEST_INFO, resp.data)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.GET_LAST_LOT_REQUEST_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/last?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LAST_LOT_REQUEST_INFO, resp.data)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.GET_LAST_SESSION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/session/${model.sessionId}/last?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LAST_SESSION_REQUEST, resp.data)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.CREATE_LOT_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}`,
      model: model.request
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.CREATE_SESSION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}`,
      model: model.session
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.UPDATE_SESSION_REQUEST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/requests/${model.requestType}/${model.requestId}`,
      model: model.session
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.CLEAR_LOT_REQUEST_INFO] ({ commit }) {
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LOT_REQUEST_INFO)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.CLEAR_LOT_REQUESTS] ({ commit }) {
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LOT_REQUESTS)
  },
  async [LOT_REQUESTS_MANAGEMENT.ACTIONS.CLEAR_LAST_LOT_REQUEST_INFO] ({ commit }) {
    commit(LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LAST_LOT_REQUEST_INFO)
  }
}

const mutations = {
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LOT_REQUEST_INFO] (state, position) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.CURRENT_REQUEST] = position
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LOT_REQUESTS] (state, requests) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.REQUESTS] = requests
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LAST_LOT_REQUEST_INFO] (state, request) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.LAST] = request
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.GET_LAST_SESSION_REQUEST] (state, request) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.LAST] = request
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LOT_REQUEST_INFO] (state) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.CURRENT_REQUEST] = null
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LOT_REQUESTS] (state) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.REQUESTS] = null
  },
  [LOT_REQUESTS_MANAGEMENT.MUTATIONS.CLEAR_LAST_LOT_REQUEST_INFO] (state) {
    state[LOT_REQUESTS_MANAGEMENT.STATE.LAST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
